import { defineComponent as d, openBlock as o, createElementBlock as e, mergeProps as A, unref as a, renderSlot as p, createElementVNode as n, createCommentVNode as i } from "vue";
import { useScalarIcon as u } from "../hooks/useScalarIcon.js";
const g = { key: 0 }, f = { key: 1 }, M = { key: 2 }, V = { key: 3 }, k = { key: 4 }, v = { key: 5 }, h = {
  name: "ScalarIconInfo"
}, _ = /* @__PURE__ */ d({
  ...h,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: m, weight: l } = u(s);
    return (Z, t) => (o(), e("svg", A({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, a(m)), [
      p(Z.$slots, "default"),
      a(l) === "bold" ? (o(), e("g", g, t[0] || (t[0] = [
        n("path", { d: "M108,84a16,16,0,1,1,16,16A16,16,0,0,1,108,84Zm128,44A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Zm-72,36.68V132a20,20,0,0,0-20-20,12,12,0,0,0-4,23.32V168a20,20,0,0,0,20,20,12,12,0,0,0,4-23.32Z" }, null, -1)
      ]))) : a(l) === "duotone" ? (o(), e("g", f, t[1] || (t[1] = [
        n("path", {
          d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M144,176a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176Zm88-48A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128ZM124,96a12,12,0,1,0-12-12A12,12,0,0,0,124,96Z" }, null, -1)
      ]))) : a(l) === "fill" ? (o(), e("g", M, t[2] || (t[2] = [
        n("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm-4,48a12,12,0,1,1-12,12A12,12,0,0,1,124,72Zm12,112a16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40a8,8,0,0,1,0,16Z" }, null, -1)
      ]))) : a(l) === "light" ? (o(), e("g", V, t[3] || (t[3] = [
        n("path", { d: "M142,176a6,6,0,0,1-6,6,14,14,0,0,1-14-14V128a2,2,0,0,0-2-2,6,6,0,0,1,0-12,14,14,0,0,1,14,14v40a2,2,0,0,0,2,2A6,6,0,0,1,142,176ZM124,94a10,10,0,1,0-10-10A10,10,0,0,0,124,94Zm106,34A102,102,0,1,1,128,26,102.12,102.12,0,0,1,230,128Zm-12,0a90,90,0,1,0-90,90A90.1,90.1,0,0,0,218,128Z" }, null, -1)
      ]))) : a(l) === "regular" ? (o(), e("g", k, t[4] || (t[4] = [
        n("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z" }, null, -1)
      ]))) : a(l) === "thin" ? (o(), e("g", v, t[5] || (t[5] = [
        n("path", { d: "M140,176a4,4,0,0,1-4,4,12,12,0,0,1-12-12V128a4,4,0,0,0-4-4,4,4,0,0,1,0-8,12,12,0,0,1,12,12v40a4,4,0,0,0,4,4A4,4,0,0,1,140,176ZM124,92a8,8,0,1,0-8-8A8,8,0,0,0,124,92Zm104,36A100,100,0,1,1,128,28,100.11,100.11,0,0,1,228,128Zm-8,0a92,92,0,1,0-92,92A92.1,92.1,0,0,0,220,128Z" }, null, -1)
      ]))) : i("", !0)
    ], 16));
  }
});
export {
  _ as default
};
